import { TicketDataState } from './tickets.firestore.reducer';
import { createFeatureSelector } from '@ngrx/store';
import { FIRESTORE_COLLECTION_TICKETS } from '../firestore/allFirestoreCollections';

export const ticketDataState = createFeatureSelector<TicketDataState>(FIRESTORE_COLLECTION_TICKETS);
